import { Injectable } from '@angular/core';
import { Observable, Subject, of, shareReplay, startWith, switchMap } from 'rxjs';
import { Country } from '../../models/country';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Logger } from '../logger.service';

const log = new Logger('CountryService');

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private _refreshTrigger$ = new Subject();
  private _countries$: Observable<Country[]>;

  constructor(private httpClient: HttpClient) {
    this._countries$ = this._refreshTrigger$.pipe(
      startWith(null as unknown),
      switchMap(() => {
        log.info('Getting list of sites');

        return this.httpClient.get<Country[]>(`${environment.apiBaseUrl}/countries`);
      }),
      shareReplay(1)
    );
  }

  public get countries$(): Observable<Country[]> {
    return this._countries$;
  }

  public triggerReload() {
    this._refreshTrigger$.next(null);
  }
}
